var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"fixed","inset":"0","z-index":"1"},attrs:{"id":"tsparticles"}})
}
var staticRenderFns = []

export { render, staticRenderFns }